import { checkResponse, post, get } from '@/helpers/http'

const API_URI = 'https://privacy.platform.ue.co'

export function login (data) {
  const referrer = typeof document.referrer === 'string' && document.referrer !== '' ? document.referrer : 'n/a'
  const payload = {
    'email': data.payload.email,
    'phone': data.payload.phone,
    'first_name': data.payload.first_name,
    'last_name': data.payload.last_name,
    'channel': data.payload.verification_type,
    'trusted_form_token': data.trustedFormToken,
    'referrer': referrer
  }

  return post(API_URI + '/auth/login', payload)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function verifyToken (data) {
  const payload = {
    'confirmation_code': data.formData.token
  }
  return post(API_URI + '/auth/confirm', payload, data.userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function checkToken (userId) {
  return get(API_URI + '/auth/verify/' + userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function fetchLead (userId, pii) {
  // TODO: Get rid of the pii object, no longer need it.
  return get(API_URI + '/show', '', userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function requestDnc (userId) {
  const payload = {
    'scopes': [
      'dnc'
    ]
  }

  return post(API_URI + '/optout', payload, userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function requestDns (userId) {
  const payload = {
    'scopes': [
      'dns'
    ]
  }

  return post(API_URI + '/optout', payload, userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}

export function requestDelete (userId) {
  const payload = {
    'scopes': [
      'delete'
    ]
  }

  return post(API_URI + '/optout', payload, userId)
    .then(checkResponse).then(function (response) {
      return response
    })
}
